var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 16C5.14062 16 2.51562 14.5 1.07812 12C-0.359375 9.53125 -0.359375 6.5 1.07812 4C2.51562 1.53125 5.14062 0 8.01562 0C10.8594 0 13.4844 1.53125 14.9219 4C16.3594 6.5 16.3594 9.53125 14.9219 12C13.4844 14.5 10.8594 16 8.01562 16ZM11.5469 6.53125H11.5156C11.8281 6.25 11.8281 5.78125 11.5156 5.46875C11.2344 5.1875 10.7656 5.1875 10.4844 5.46875L7.01562 8.96875L5.54688 7.5C5.23438 7.1875 4.76562 7.1875 4.48438 7.5C4.17188 7.78125 4.17188 8.25 4.48438 8.53125L6.48438 10.5312C6.76562 10.8438 7.23438 10.8438 7.54688 10.5312L11.5469 6.53125Z",
    fill: "#2FB273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a94519ac0eb6d3c8c9f7d898fe858c5c.svg";
export { ForwardRef as ReactComponent };